export default {
  unreadNotifications: [],
  notifications: [],
  pageable: null,
  unreadCount: null,
  hasNext: false,
  notificationFilter: "index",
  notificationSearchQuery: "",
  categories: [
    { id: 1, text: "すべて", value: "all", color: "grey" },
    { id: 2, text: "お知らせ", value: "info", color: "primary" }
  ]
};
